import React from "react";
import styles from "./footer.module.css";
import { ReactComponent as FooterTop } from "../../assets/img/footer/footerTop.svg";
import { ReactComponent as FooterBottom } from "../../assets/img/footer/footerBottom.svg";
import { ReactComponent as FooterLeft } from "../../assets/img/footer/footerLeft.svg";
import { ReactComponent as FooterRight } from "../../assets/img/footer/footerRight.svg";
import { ReactComponent as Twitter } from "../../assets/img/footer/twitter.svg";
import { ReactComponent as Discord } from "../../assets/img/footer/discord.svg";
import { ReactComponent as Telegram } from "../../assets/img/footer/telegram.svg";
import { ReactComponent as PlusSvg } from "../../assets/img/footer/plus.svg";
import FooterLogo from "../../assets/img/footer/footerLogo.png";

const Footer = () => {
  return (
    <footer className={styles.footerWrapper}>
      <div className={styles.footer}>
        <div className={styles.footerLogoBlock}>
          <img src={FooterLogo} alt="footer logo" />
          <FooterLeft className={styles.footerLeftSvg} />
          <FooterRight className={styles.footerRightSvg} />
          <div className={styles.followUs}>Follow us</div>
        </div>
        <div className={styles.followSvgBlock}>
          <Twitter
            onClick={() => {
              window.open("https://twitter.com/MechNFT");
            }}
          />
          <PlusSvg />
          {/* <Discord
            onClick={() => {
              window.open("https://discord.com/invite/mechnft");
            }}
          />
          <PlusSvg /> */}
          <Telegram
            onClick={() => {
              window.open("https://t.me/mechnft");
            }}
          />
        </div>
        <FooterTop className={styles.footerTopSvg} />
        <FooterBottom className={styles.footerBottomSvg} />
      </div>
      <div className={styles.footerBottomBlock}>
        <div className={styles.footerBottomBlockLeft}>
          <div>
            <a
              href="https://app.termly.io/document/privacy-policy/8e5b3052-8995-4b63-a027-38985913e9d4"
              target="_blank"
            >
              Privacy Policy
            </a>
          </div>
          <div className={styles.footerBottomBlockLeftLine}></div>
          <div>
            <a
              href="https://app.termly.io/document/terms-of-use-for-online-marketplace/73598e04-0919-4bf3-8a9c-5104b75cdde6"
              target="_blank"
            >
              Terms Of Service
            </a>
          </div>
          <div className={styles.footerBottomBlockLeftLine}></div>
          <div>
            <a
              href="#"
              onClick={() => {
                window.displayPreferenceModal();
                return false;
              }}
              id="termly-consent-preferences"
            >
              Consent Preferences
            </a>
          </div>
        </div>
        <div className={styles.footerBottomBlockRight}>
          All Right Reserved 2023
        </div>
      </div>
    </footer>
  );
};

export default Footer;
